import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AdminProvider } from './context/adminContext';
import ProjectProvider from './context/ProjectContext';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ProjectProvider>
    <AdminProvider>
      <React.StrictMode>
        <App />
        <ToastContainer position='top-right' auto-close={200}/>
      </React.StrictMode>
    </AdminProvider>
  </ProjectProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
